import { useNavigate } from 'react-router-dom'
import { useModal } from '../../contexts/ModalContext'
import { useLogout } from '../../hooks/auth/useLogout'
import { ScreenPath } from '../../navigation'
import { logError } from '../../util/errorLogger'
import Button from '../primitives/Button'
import styles from './ProfileScreen.module.css'

export default function AccountActions({ onEdit }: { onEdit: () => void }) {
  const navigate = useNavigate()
  const { showSnackbar } = useModal()
  const logout = useLogout()

  async function handleLogout() {
    try {
      await logout.mutateAsync()
      navigate(ScreenPath.login, { replace: true })
    } catch (error) {
      void logError(error, { screen: 'Profile', action: 'logout' })
      showSnackbar('logout-error', 'Sorry! There was a problem logging you out.', 'error')
    }
  }

  return (
    <div className={styles.accountActions}>
      <Button onClick={onEdit}>Edit profile</Button>
      <Button variant="ghost" onClick={handleLogout} disabled={logout.isPending}>
        Log out
      </Button>
    </div>
  )
}
